import { useState } from "react";
import { type Identifier } from "ra-core";

import { CampaignProgressSummaryPanel } from "./CampaignProgressSummary";
import { CampaignProgressByDefinition } from "./CampaignProgressByDefinition";
import { CampaignProgressBySalesperson } from "./CampaignProgressBySalesperson";
import { CampaignOpenTasksList } from "./CampaignOpenTasksList";

export const CampaignOverview = ({ campaignId }: { campaignId: Identifier }) => {
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [definitionFilter, setDefinitionFilter] = useState<Identifier | null>(
    null,
  );
  const [salesFilter, setSalesFilter] = useState<Identifier | null>(null);
  const [showCompleted, setShowCompleted] = useState(false);

  return (
    <div className="flex flex-col gap-6">
      <CampaignProgressSummaryPanel
        campaignId={campaignId}
        activeStatus={statusFilter}
        onFilterStatus={setStatusFilter}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <CampaignProgressByDefinition
          campaignId={campaignId}
          selectedDefinitionId={definitionFilter}
          onSelectDefinition={setDefinitionFilter}
        />
        <CampaignProgressBySalesperson
          campaignId={campaignId}
          selectedSalesId={salesFilter}
          onSelectSalesperson={setSalesFilter}
        />
      </div>
      <CampaignOpenTasksList
        campaignId={campaignId}
        statusFilter={statusFilter}
        definitionFilter={definitionFilter}
        salesFilter={salesFilter}
        showCompleted={showCompleted}
        onToggleShowCompleted={setShowCompleted}
      />
    </div>
  );
};
